import React, { Fragment } from 'react'
import { Link } from 'gatsby'
import classnames from 'classnames'
import UAParser from 'ua-parser-js'

import style from './header.module.scss'

import userAvatarPlaceholder from '../images/user-avatar-placeholder.png'

const isMobile = () => new UAParser().getResult().device.type === 'mobile'

class Header extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      hasCta: false,
      userAuthenticated: false,
      isOpen: false,
      userProfile: {
        displayName: 'Name Lastname',
        avatar: userAvatarPlaceholder,
      },
      toggle: {
        solutions: false,
        hiring: false,
        resources: false,
      },
      selectedMenuItem: null,
    }

    this.handleHamburgerClick = this.handleHamburgerClick.bind(this)
    this.handleMouseEnter = this.handleMouseEnter.bind(this)
    this.handleMouseLeave = this.handleMouseLeave.bind(this)
    this.handleToggleClick = this.handleToggleClick.bind(this)
    this.generateChildren = this.generateChildren.bind(this)
  }

  componentDidMount() {
    // this is just a place holder. Integration Team should real real cookies or receive
    // authentication information for an API.
    if (
      window.document.cookie &&
      window.document.cookie.indexOf('authenticated') >= 0
    ) {
      this.setState({
        userAuthenticated: true,
      })
    }
  }

  generateChildren(menuItem, isPrimaryActive, isSecondaryActive) {
    switch (menuItem) {
      case 'hiring':
        return (
          <ul aria-label="submenu">
            <li className={style.mobileOnly}>
              <Link id={menuItem} to="/hiring" getProps={isSecondaryActive}>
                All specialty hiring
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/hiring/diversity"
                getProps={isSecondaryActive}
              >
                Diversity
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/hiring/veterans"
                getProps={isSecondaryActive}
              >
                Veterans
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/hiring/healthcare"
                getProps={isSecondaryActive}
              >
                Healthcare
              </Link>
            </li>
            <li>
              <Link id={menuItem} to="/hiring/it" getProps={isSecondaryActive}>
                IT
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/hiring/early-career"
                getProps={isSecondaryActive}
              >
                Emerging workforce
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/hiring/staffing-agencies"
                getProps={isSecondaryActive}
              >
                Staffing agencies
              </Link>
            </li>
          </ul>
        )
      case 'resources':
        return (
          <ul aria-label="submenu">
            <li className={style.mobileOnly}>
              <Link id={menuItem} to="/resources" getProps={isSecondaryActive}>
                All resources
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/resources/job-description-templates"
                getProps={isSecondaryActive}
              >
                Job description templates
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/resources/recruiting-strategies"
                getProps={isSecondaryActive}
              >
                Recruiting strategies
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/resources/workplace-management-training"
                getProps={isSecondaryActive}
              >
                Workplace management & planning
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/resources/monster-training"
                getProps={isSecondaryActive}
              >
                Monster training
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/resources/small-business-hiring"
                getProps={isSecondaryActive}
              >
                Small business hiring
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/resources/blog"
                getProps={isSecondaryActive}
              >
                Blog
              </Link>
            </li>
          </ul>
        )
      case 'solutions':
        return (
          <ul aria-label="submenu">
            <li className={style.mobileOnly}>
              <Link to="/solutions" getProps={isSecondaryActive}>
                All hiring solutions
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/solutions/post-job-resume-search"
                getProps={isSecondaryActive}
              >
                Post jobs & resume search
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/solutions/employer-branding"
                getProps={isSecondaryActive}
              >
                Employer branding
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/solutions/full-service-staffing"
                getProps={isSecondaryActive}
              >
                Full service sourcing
              </Link>
            </li>
            <li>
              <Link
                id={menuItem}
                to="/solutions/software-data-solutions"
                getProps={isSecondaryActive}
              >
                Software & data solutions
              </Link>
            </li>
          </ul>
        )
      default:
        return null
    }
  }

  handleMouseEnter(e) {
    this.setState({
      selectedMenuItem: e.target.id,
    })
  }

  handleMouseLeave(e) {
    this.setState({
      selectedMenuItem: null,
    })
  }

  handleHamburgerClick() {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen,
    }))
  }

  handleToggleClick(toggle) {
    let nextToggle = this.state.toggle
    nextToggle[toggle] = !this.state.toggle[toggle]
    this.setState({
      toggle: nextToggle,
    })
  }

  renderUserBlock() {
    const { userAuthenticated, userProfile } = this.state

    if (userAuthenticated && userProfile) {
      const { displayName } = userProfile

      return (
        <span className={style.signIn}>
          <img
            src={userAvatarPlaceholder}
            alt="user avatar"
            className={style.userAvatar}
          />
          <span className={style.signInLabel}>{displayName}</span>
          <i className={style.down} />
        </span>
      )
    }

    return (
      <Link to="/sign-in" className={style.signIn}>
        <i className={`material-icons ${style.defaultAvatar}`}>
          account_circle
        </i>
        <span className={style.signInLabel}>Sign In</span>
      </Link>
    )
  }

  render() {
    const isPrimaryActive = ({ isPartiallyCurrent }) => {
      return isPartiallyCurrent ? { className: style.menuPrimaryActive } : null
    }
    const isPrimaryActiveInMobile = path =>
      typeof window !== 'undefined' &&
      window.location.pathname.indexOf(path) > -1
        ? style.menuPrimaryActive
        : null
    const { isOpen, hasCta, userAuthenticated } = this.state
    const isSecondaryActive = ({ isCurrent }) => {
      return isCurrent ? { className: style.menuSecondaryActive } : null
    }

    let classes = style.header
    // if (this.state.isPinned) {
    //   classes += ' ' + style.headerPinned
    // }
    if (isOpen) {
      classes += ' ' + style.headerOpen
    }
    if (hasCta) {
      classes += ' ' + style.hasCta
    }

    if (userAuthenticated) {
      classes += ' ' + style.authenticated
    }

    const menuItems = [
      { key: 'solutions', label: 'Solutions' },
      { key: 'hiring', label: 'Specialty Hiring' },
      { key: 'pricing', label: 'Pricing' },
      { key: 'resources', label: 'Resource Center' },
    ]
    const withArrow = ['solutions', 'hiring', 'resources']
    const mainLinkDesktopClasses = classnames(style.mainLink, style.desktopOnly)
    const mainLinkMobileClasses = classnames(style.mainLink, style.mobileOnly)

    return (
      <header className={classes}>
        {this.state.hasCta && (
          <div className={style.headerCta}>
            <div className="container">
              <h3>Post Jobs CTA With Wicked Big Text</h3>
              <button className="button-orange">Start Hiring Now</button>
            </div>
          </div>
        )}

        <div role="navigation" className={style.mainNav}>
          <div className={style.hamburger} onClick={this.handleHamburgerClick}>
            <div />
          </div>

          <Link to="/" className={style.logo}>
            <img
              src={require('../images/logo.svg')}
              alt="Monster logo"
              className="hidden-mobile"
            />
            <img
              src={require('../images/icon.svg')}
              alt="Monster icon"
              className="hidden-desktop"
            />
          </Link>

          <nav>
            <ul>
              {menuItems.map(menuItem => {
                const hasArrow = withArrow.includes(menuItem.key)
                return (
                  <li
                    className={
                      this.state.toggle[menuItem.key]
                        ? style.subnavOpen
                        : style.subnav
                    }
                    key={menuItem.key}
                    id={menuItem.key}
                    onMouseEnter={this.handleMouseEnter}
                    onMouseLeave={this.handleMouseLeave}
                  >
                    {hasArrow ? (
                      <button
                        type="button"
                        id={menuItem.key}
                        className={mainLinkMobileClasses}
                        onClick={() => this.handleToggleClick(menuItem.key)}
                      >
                        <span
                          id={menuItem.key}
                          className={isPrimaryActiveInMobile(menuItem.key)}
                        >
                          {menuItem.label}
                        </span>
                        {hasArrow && <span className={style.toggler} />}
                      </button>
                    ) : (
                      <div id={menuItem.key} className={mainLinkMobileClasses}>
                        <Link
                          id={menuItem.key}
                          to={`/${menuItem.key}`}
                          getProps={isPrimaryActive}
                        >
                          {menuItem.label}
                        </Link>
                      </div>
                    )}
                    <div
                      id={menuItem.key}
                      className={mainLinkDesktopClasses}
                      aria-label="submenu"
                    >
                      <Link
                        id={menuItem.key}
                        to={`/${menuItem.key}`}
                        getProps={isPrimaryActive}
                      >
                        {menuItem.label}
                      </Link>
                      {hasArrow && (
                        <Fragment>
                          <i
                            id={menuItem.key}
                            className={
                              menuItem.key.includes(this.state.selectedMenuItem)
                                ? style.up
                                : style.down
                            }
                          />
                          <button
                            type="button"
                            className={style.toggler}
                            onClick={() => this.handleToggleClick(menuItem.key)}
                          />
                        </Fragment>
                      )}
                    </div>
                    {this.generateChildren(
                      menuItem.key,
                      isPrimaryActive,
                      isSecondaryActive
                    )}
                  </li>
                )
              })}
            </ul>
            <div className={style.phoneMobile}>
              {isMobile() ? (
                <a href="tel:+18006667837">
                  <span className="material-icons">phone</span>1-800-Monster
                </a>
              ) : (
                <Fragment>
                  <span className="material-icons">phone</span>1-800-Monster
                </Fragment>
              )}
            </div>
          </nav>

          <div className={style.phoneDesktop}>
            <span className="material-icons">phone</span>1-800-Monster
          </div>

          {this.renderUserBlock()}
        </div>
      </header>
    )
  }
}

export default Header
